export const GET_LISTINGS = 'GET_LISTINGS';
export const CLEAR_LISTINGS = 'CLEAR_LISTINGS';
export const SET_ORG_LISTINGS = 'SET_ORG_LISTINGS';
export const GET_LISTING = 'GET_LISTING';
export const UPDATE_LISTING_IMAGE = 'UPDATE_LISTING_IMAGE';
export const UPADTE_LISTING_BLOBURL = 'UPADTE_LISTING_BLOBURL';
export const UPADTE_LISTING_UNUSED_BLOBURLS = 'UPADTE_LISTING_UNUSED_BLOBURLS';
export const UPDATE_LISTING = 'UPDATE_LISTING';
export const DELETE_ORG_LISTING = 'DELETE_ORG_LISTING';
export const UPADTE_ORG_LISTING_BLOBURL = 'UPADTE_ORG_LISTING_BLOBURL';
export const UPDATE_ORG_LISTINGS = 'UPDATE_ORG_LISTINGS';
export const UPDATE_ORG_LISTINGS_APPLICATION_NUMBERS =
  'UPDATE_ORG_LISTINGS_APPLICATION_NUMBERS';
export const UPADTE_ORG_LISTING_UNUSED_BLOBURLS =
  'UPADTE_ORG_LISTING_UNUSED_BLOBURLS';
export const UPADTE_UNIV_LISTING = 'UPADTE_UNIV_LISTING';
export const ADD_NEW_LISTING = 'ADD_NEW_LISTING';
